import { api } from '../../services/api'
import { showError, showSuccess } from '../misc/misc.actions'

export const redeemPromotionForFacilityVisit = async (
	dispatch,
	{ promo_code, visit_id, household_id, service_target }
) => {
	dispatch({ type: 'REDEEM_PROMOTION' })
	const payload = {
		success: false,
		redemption_error: null,
		service_target,
		promo_code
	}
	try {
		const response = await api.post(`/visits/${visit_id}/promo/redeem/${promo_code}`, {
			household_id,
			visit_id,
			service_target
		})
		const { data, errors } = response.data
		if (data && data.length > 0) {
			const [updatedVisit] = data
			dispatch(showSuccess('Promotion redeemed successfully!'))
			dispatch({ type: 'REDEEM_PROMOTION_SUCCESS' })
			dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: { visit: updatedVisit } })
			payload.success = true
		} else if (errors && errors.length > 0) {
			payload.redemption_error = errors[0]
			dispatch({ type: 'REDEEM_PROMOTION_FAIL', payload: null })
		}
	} catch (e) {
		dispatch({ type: 'REDEEM_PROMOTION_FAIL', payload: null })
		dispatch(showError(e.message))
	} finally {
		return payload
	}
}

export const deletePromotionForFacilityVisit = async (
	dispatch,
	{ promo_code, promo_id, visit_id, household_id }
) => {
	dispatch({ type: 'DELETE_PROMOTION' })
	const payload = {
		success: false
	}
	try {
		const response = await api.patch(`/visits/${visit_id}/promo/delete`, {
			household_id,
			promo_code,
			promo_id
		})
		const { data, errors } = response.data
		if (data && data.length > 0) {
			const [updatedVisit] = data
			dispatch(showSuccess('Promotion removed successfully!'))
			dispatch({ type: 'DELETE_PROMOTION_SUCCESS' })
			dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: { visit: updatedVisit } })
			payload.success = true
		} else if (errors && errors.length > 0) {
			dispatch({ type: 'DELETE_PROMOTION_FAIL', payload: null })
		}
	} catch (e) {
		dispatch({ type: 'DELETE_PROMOTION_FAIL', payload: null })
		dispatch(showError(e.message))
	} finally {
		return payload
	}
}
